import { render, staticRenderFns } from "./CustomerSupportIcon.vue?vue&type=template&id=3140bbaa"
import script from "./CustomerSupportIcon.vue?vue&type=script&lang=ts"
export * from "./CustomerSupportIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports